var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-smaller-ads ad-slot"},[_c('div',{staticClass:"ad_container"},[_c('div',{staticClass:"ad_wrapper"},[(_vm.screen.isDesktop)?_c('div',{attrs:{"id":"div-gpt-ad-1556609068299-0"}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }